import type { ItemDefInput } from '../../schemas/items';
import { HERITAGE_FURNITURE } from './heritage';
import { STUDIO_FURNITURE } from './studio';

/** Furniture (docs/design/content-items.md §B). Starter pieces are re-buyable in the Home catalog (unl_home). */
export const FURNITURE = [
  {
    id: 'fur_bed_pine',
    kind: 'furniture',
    nameKey: 'item.fur_bed_pine.name',
    loreKey: 'item.fur_bed_pine.lore',
    shopTab: 'furniture',
    layer: 'object',
    footprint: { w: 2, h: 3 },
    rotations: 4,
    tags: ['bed'],
    homeTags: ['zone:corner'],
    themeTags: ['cozy'],
    setId: 'set_pine',
    unlockId: 'unl_home',
    buyPrice: 200,
    material: 'wood',
    sources: [{ kind: 'starter', boxId: 'box_01_sleep' }, { kind: 'catalog' }],
    sprite: { frame: 'item_fur_bed_pine' },
  },
  {
    id: 'fur_nightstand_pine',
    kind: 'furniture',
    nameKey: 'item.fur_nightstand_pine.name',
    loreKey: 'item.fur_nightstand_pine.lore',
    shopTab: 'furniture',
    layer: 'object',
    footprint: { w: 1, h: 1 },
    rotations: 2,
    tags: ['nightstand'],
    homeTags: ['near:bed'],
    themeTags: ['cozy'],
    setId: 'set_pine',
    unlockId: 'unl_home',
    buyPrice: 70,
    slots: { count: 2, surfaceTag: 'nightstand', accepts: [{ kinds: ['decor'], layers: ['surface'] }] },
    material: 'wood',
    sources: [{ kind: 'starter', boxId: 'box_01_sleep' }, { kind: 'catalog' }],
    sprite: { frame: 'item_fur_nightstand_pine' },
  },
  {
    id: 'fur_wardrobe_pine',
    kind: 'furniture',
    nameKey: 'item.fur_wardrobe_pine.name',
    loreKey: 'item.fur_wardrobe_pine.lore',
    shopTab: 'furniture',
    layer: 'object',
    footprint: { w: 2, h: 1 },
    rotations: 4,
    tags: ['wardrobe', 'storage'],
    homeTags: ['wall-adjacent'],
    themeTags: ['cozy'],
    setId: 'set_pine',
    unlockId: 'unl_home',
    buyPrice: 160,
    material: 'wood',
    sources: [{ kind: 'catalog' }],
    sprite: { frame: 'item_fur_wardrobe_pine' },
  },
  {
    id: 'fur_desk_pine',
    kind: 'furniture',
    nameKey: 'item.fur_desk_pine.name',
    loreKey: 'item.fur_desk_pine.lore',
    shopTab: 'furniture',
    layer: 'object',
    footprint: { w: 2, h: 1 },
    rotations: 4,
    tags: ['desk'],
    homeTags: ['zone:window'],
    themeTags: ['office', 'cozy'],
    setId: 'set_pine',
    unlockId: 'unl_home',
    buyPrice: 120,
    slots: { count: 3, surfaceTag: 'desk', accepts: [{ kinds: ['decor'], layers: ['surface'] }] },
    material: 'wood',
    sources: [{ kind: 'starter', boxId: 'box_02_work' }, { kind: 'catalog' }],
    sprite: { frame: 'item_fur_desk_pine' },
  },
  {
    id: 'fur_chair_pine',
    kind: 'furniture',
    nameKey: 'item.fur_chair_pine.name',
    loreKey: 'item.fur_chair_pine.lore',
    shopTab: 'furniture',
    layer: 'object',
    footprint: { w: 1, h: 1 },
    rotations: 4,
    tags: ['chair', 'seat'],
    homeTags: ['near:desk'],
    themeTags: ['cozy'],
    setId: 'set_pine',
    unlockId: 'unl_home',
    buyPrice: 50,
    material: 'wood',
    sources: [{ kind: 'starter', boxId: 'box_02_work' }, { kind: 'catalog' }],
    sprite: { frame: 'item_fur_chair_pine' },
  },
  {
    id: 'fur_sofa_pink',
    kind: 'furniture',
    nameKey: 'item.fur_sofa_pink.name',
    loreKey: 'item.fur_sofa_pink.lore',
    shopTab: 'furniture',
    layer: 'object',
    footprint: { w: 2, h: 1 },
    rotations: 4,
    tags: ['sofa', 'seat'],
    homeTags: ['zone:center'],
    themeTags: ['cute'],
    setId: 'set_strawberry',
    unlockId: 'unl_catalog_t2',
    buyPrice: 220,
    slots: { count: 2, surfaceTag: 'sofa', accepts: [{ kinds: ['decor'], layers: ['surface'] }] },
    material: 'fabric',
    sources: [{ kind: 'catalog' }],
    sprite: { frame: 'item_fur_sofa_pink' },
  },
  {
    id: 'fur_coffee_table',
    kind: 'furniture',
    nameKey: 'item.fur_coffee_table.name',
    loreKey: 'item.fur_coffee_table.lore',
    shopTab: 'furniture',
    layer: 'object',
    footprint: { w: 1, h: 1 },
    rotations: 1,
    tags: ['table'],
    homeTags: ['near:sofa'],
    themeTags: ['cozy'],
    unlockId: 'unl_home',
    buyPrice: 80,
    slots: { count: 2, surfaceTag: 'table', accepts: [{ kinds: ['decor'], layers: ['surface'] }] },
    material: 'wood',
    sources: [{ kind: 'catalog' }],
    sprite: { frame: 'item_fur_coffee_table' },
  },
  {
    id: 'fur_bookshelf',
    kind: 'furniture',
    nameKey: 'item.fur_bookshelf.name',
    loreKey: 'item.fur_bookshelf.lore',
    shopTab: 'furniture',
    layer: 'object',
    footprint: { w: 2, h: 1 },
    rotations: 2,
    tags: ['bookshelf', 'storage'],
    homeTags: ['wall-adjacent'],
    themeTags: ['cozy'],
    unlockId: 'unl_home',
    buyPrice: 140,
    // 0-3 on the two shelves inside, 4-5 on top (the only place a lamp lights anything).
    slots: {
      count: 6,
      surfaceTag: 'bookshelf',
      accepts: [{ kinds: ['decor'], layers: ['surface'] }],
      inner: [0, 1, 2, 3],
    },
    material: 'wood',
    sources: [{ kind: 'starter', boxId: 'box_03_books' }, { kind: 'catalog' }],
    sprite: { frame: 'item_fur_bookshelf' },
  },
  {
    id: 'fur_kitchen_counter',
    kind: 'furniture',
    nameKey: 'item.fur_kitchen_counter.name',
    loreKey: 'item.fur_kitchen_counter.lore',
    shopTab: 'furniture',
    layer: 'object',
    footprint: { w: 2, h: 1 },
    rotations: 2,
    tags: ['kitchen'],
    homeTags: ['zone:kitchen'],
    themeTags: ['cozy'],
    unlockId: 'unl_home',
    buyPrice: 150,
    slots: { count: 3, surfaceTag: 'kitchen_counter', accepts: [{ kinds: ['decor'], layers: ['surface'] }] },
    material: 'wood',
    sources: [{ kind: 'starter', boxId: 'box_04_kitchen' }, { kind: 'catalog' }],
    sprite: { frame: 'item_fur_kitchen_counter' },
  },
  {
    id: 'fur_office_chair',
    kind: 'furniture',
    nameKey: 'item.fur_office_chair.name',
    loreKey: 'item.fur_office_chair.lore',
    shopTab: 'furniture',
    layer: 'object',
    footprint: { w: 1, h: 1 },
    rotations: 4,
    tags: ['chair', 'seat'],
    homeTags: ['near:desk'],
    themeTags: ['office'],
    setId: 'set_office',
    unlockId: 'unl_catalog_t2',
    buyPrice: 130,
    material: 'fabric',
    sources: [{ kind: 'catalog' }, { kind: 'gift', npcId: 'npc_bao', level: 3 }],
    sprite: { frame: 'item_fur_office_chair' },
  },
  {
    id: 'fur_floor_lamp',
    kind: 'furniture',
    nameKey: 'item.fur_floor_lamp.name',
    loreKey: 'item.fur_floor_lamp.lore',
    shopTab: 'furniture',
    layer: 'object',
    footprint: { w: 1, h: 1 },
    rotations: 1,
    tags: ['lamp', 'light'],
    homeTags: ['zone:corner'],
    themeTags: ['cozy'],
    unlockId: 'unl_home',
    buyPrice: 90,
    material: 'metal',
    sources: [{ kind: 'catalog' }],
    sprite: { frame: 'item_fur_floor_lamp' },
  },
  {
    id: 'fur_cat_bed',
    kind: 'furniture',
    nameKey: 'item.fur_cat_bed.name',
    loreKey: 'item.fur_cat_bed.lore',
    shopTab: 'furniture',
    layer: 'object',
    footprint: { w: 1, h: 1 },
    rotations: 1,
    tags: ['cat', 'pet'],
    homeTags: ['zone:window'],
    themeTags: ['pet'],
    material: 'fabric',
    sources: [{ kind: 'gift', npcId: 'npc_boss_cat', level: 1 }],
    sprite: { frame: 'item_fur_cat_bed' },
  },
  {
    id: 'fur_cat_tree',
    kind: 'furniture',
    nameKey: 'item.fur_cat_tree.name',
    loreKey: 'item.fur_cat_tree.lore',
    shopTab: 'furniture',
    layer: 'object',
    footprint: { w: 1, h: 1 },
    rotations: 2,
    tags: ['cat', 'pet'],
    homeTags: ['zone:window'],
    themeTags: ['pet'],
    unlockId: 'unl_catalog_t3',
    buyPrice: 160,
    material: 'fabric',
    sources: [{ kind: 'catalog' }],
    sprite: { frame: 'item_fur_cat_tree' },
  },
  {
    id: 'fur_plant_stand',
    kind: 'furniture',
    nameKey: 'item.fur_plant_stand.name',
    loreKey: 'item.fur_plant_stand.lore',
    shopTab: 'plants',
    layer: 'object',
    footprint: { w: 1, h: 1 },
    rotations: 2,
    tags: ['plant', 'plant_stand'],
    homeTags: ['zone:window'],
    themeTags: ['garden'],
    setId: 'set_garden',
    unlockId: 'unl_catalog_t2',
    buyPrice: 100,
    slots: { count: 3, surfaceTag: 'plant_stand', accepts: [{ kinds: ['decor'], layers: ['surface'] }] },
    material: 'wood',
    sources: [{ kind: 'catalog' }],
    sprite: { frame: 'item_fur_plant_stand' },
  },
  {
    id: 'fur_beanbag_pink',
    kind: 'furniture',
    nameKey: 'item.fur_beanbag_pink.name',
    loreKey: 'item.fur_beanbag_pink.lore',
    shopTab: 'furniture',
    layer: 'object',
    footprint: { w: 1, h: 1 },
    rotations: 1,
    tags: ['seat'],
    homeTags: ['zone:corner'],
    themeTags: ['cute'],
    setId: 'set_strawberry',
    unlockId: 'unl_catalog_t2',
    buyPrice: 110,
    material: 'fabric',
    sources: [{ kind: 'catalog' }],
    sprite: { frame: 'item_fur_beanbag_pink' },
  },
  ...HERITAGE_FURNITURE,
  ...STUDIO_FURNITURE,
] as const satisfies readonly ItemDefInput[];
